import { createAction } from 'typesafe-actions';

import { FormattedTag } from 'shared/models/FormattedTag';

export const removeTag = createAction('filters/removeTag')<FormattedTag>();
